/* eslint-disable */

import ResourcePattern from '@/services/resource-patters';

export default ResourcePattern(null, 'metadata', ({ Api, resource }) => ({
  actions: {
    async get({ rootState }, { params }) {
      const { data, headers } = await Api.get(rootState.serviceName, resource, { params });
      return {
        data,
        total: Number(headers['x-total-count']),
      };
    },
    async getData({ rootState }, { id, params }) {
      const { data, headers } = await Api.get(rootState.serviceName, `${resource}/${id}/list-aggrouped`, { params });
      return {
        data,
        total: Number(headers['x-total-count']),
      };
    },
    async getByCompany({ rootState }, { companyId, transactionId, params }) {
      const { data, headers } = await Api.get(rootState.serviceName, `${resource}/company/${companyId}/${transactionId}/list`, { params });
      return {
        data,
        total: Number(headers['x-total-count']),
      };
    },
    async getDataByCompany({ rootState }, { companyId, metadataId, params }) {
      const { data, headers } = await Api.get(rootState.serviceName, `${resource}/company/${companyId}/${metadataId}/list-aggrouped`, { params });
      return {
        data,
        total: Number(headers['x-total-count']),
      };
    },
    async count({ rootState }, { params }) {
      const { data } = await Api.get(rootState.serviceName, `${resource}/count`, { params });
      return data;
    },
    async find({ rootState }, { id, params }) {
      const { data } = await Api.get(rootState.serviceName, `${resource}/${id}`, { params });
      return data;
    },
    async findByCompany({ rootState }, { companyId, id, params }) {
      const { data } = await Api.get(rootState.serviceName, `${resource}/company/${companyId}/${id}`, { params });
      return data;
    },
    async delete({ rootState }, { id }) {
      await Api.delete(rootState.serviceName, `${resource}/${id}`);
    },
    async create({ rootState }, { dataForm }) {
      const { data } = await Api.post(rootState.serviceName, `${resource}`, dataForm);
      return data;
    },
    async update({ rootState }, { id, dataForm }) {
      const { data } = await Api.patch(rootState.serviceName, `${resource}/${id}`, dataForm);
      return data;
    },
  },
}));
/* eslint-disable-line */ /* eslint-enable */
